<template>
    <div style="display:inline-block;">

        <v-popover
            offset="16"
            :options="options"
            style="display:inline-block;"
            :open="show"
            placement="left"
        >
            <!-- This will be the popover target (for the events and position) -->
            <button class="tooltip-target b3" style="display:inline-block;" @mouseover="show = true" @mouseleave="show = false">
                <i class="fas fa-usd-circle fa-fw" />
            </button>

            <!-- This will be the content of the popover -->
            <template slot="popover">
                <div class="line good">
                    <div class="left">{{ valueBased ? 'Aconto faktureret' : 'Omsætning' }}</div>
                    <div class="right good">{{ project.invoices_total ? project.invoices_total : 0 | realCurrency }}</div>
                </div>
                <div class="line bad">
                    <div class="left">{{ project.timelog_hours ? project.timelog_hours : 0 | realNumber }} timer</div>
                    <div class="right bad">{{ project.timelog_total ? project.timelog_total : 0 | realCurrency }}</div>
                </div>
                <div class="line bad">
                    <div class="left">{{ project.materials_count ? project.materials_count : 0 | realNumber }} materialer</div>
                    <div class="right bad">{{ project.material_total ? project.material_total : 0 | realCurrency }}</div>
                </div>
                <div class="line" v-if="valueBased && project.type">
                    <div class="left">Gns. DG "{{ project.type.name }}"<br><span style="opacity:0.5;font-size:12px;">DG udregnet for de seneste 6 mdr.</span></div>
                    <div class="right">{{ project.type.avg_coverage_percent | coveragePercent }} %</div>
                </div>
                <div class="divider" style="margin:10px 0;"></div>
                <div class="line total" v-if="!valueBased">
                    <div class="left">Dækningsbidrag</div>
                    <div class="right" :class="{'good': project.coverage > 0, 'bad': project.coverage < 0}">{{ project.coverage ? project.coverage : 0 | realCurrency }}</div>
                </div>
                <div class="line total" v-if="valueBased && !valueBasedWithCP">
                    <div class="left">Værdi</div>
                    <div class="right" :class="{'good': project.value > 0, 'bad': project.value < 0}">
                        {{ project.value | realCurrency }}
                        <!--{{ project.coverage ? project.coverage : 0 | realCurrency }}-->
                    </div>
                </div>
                <div class="line total" v-if="valueBased && valueBasedWithCP">
                    <div class="left">Værdi</div>
                    <div class="right" :class="{'good': project.value_with_avg_cp > 0, 'bad': project.value_with_avg_cp < 0}">
                        {{ project.value_with_avg_cp | realCurrency }}
                        <!--{{ project.coverage ? project.coverage : 0 | realCurrency }}-->
                    </div>
                </div>
            </template>
        </v-popover>

    </div>
</template>

<style lang="scss" scoped>
@import "../../styles/vars.scss";

    .tooltip-target {
        opacity: .5;

        &:hover {
            opacity: 1;
        }
    }

    .line {
        min-width: 250px;
        display: flex;
        justify-content: space-between;
        white-space: nowrap;
        margin-bottom: $margin--small / 2;
        font-weight: 600;

        .good {
            color: $color--good;
        }

        .bad {
            color: $color--bad;
        }

        &.total {
            color: inherit;
            margin-bottom: 0;
            font-weight: 700;
        }
    }

</style>

<script>
export default {
    props: {
        project: { type: Object },
        valueBased: { type: Boolean, default: false },
        valueBasedWithCP: { type: Boolean, default: false }
    },
    data () {
        return {
            show: false,
            options: {
                popover: {
                    defaultClass: 'd-tooltip',
                    defaultBaseClass: 'd-tooltip',
                    trigger: 'hover'
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// ProjectTooltip.vue?303b5089